import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import ActivityBar from "@/components/ActivityBar/ActivityBar.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import FlexPanel from "@/components/Panels/FlexPanel.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PublishedItem',
    props: {
        item: null
    },
    setup(__props) {
        const props = __props;
        const modelTitle = computed(() => {
            const modelClass = props.item?.model_class ?? "Item";
            if (modelClass == "StoredWorkflow") {
                return "Workflow";
            }
            return modelClass;
        });
        const plural = computed(() => {
            if (modelTitle.value === "History") {
                return "Histories";
            }
            return `${modelTitle.value}s`;
        });
        const gravatarSource = computed(() => `https://secure.gravatar.com/avatar/${props.item?.email_hash}?d=identicon`);
        const owner = computed(() => props.item?.owner ?? props.item?.username ?? "Unavailable");
        const pluralPath = computed(() => plural.value.toLowerCase());
        const publishedByUser = computed(() => `/${pluralPath.value}/list_published?f-username=${owner.value}`);
        const urlAll = computed(() => `/${pluralPath.value}/list_published`);
        return { __sfc: true, props, modelTitle, plural, gravatarSource, owner, pluralPath, publishedByUser, urlAll, ActivityBar, LoadingSpan, FlexPanel, StatelessTags };
    }
});
